import Head from 'next/head'
import 'tailwindcss/tailwind.css'
import 'animate.css'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import type { ReactElement, ReactNode } from 'react'
import type { NextPage } from 'next'
import type { AppProps } from 'next/app'

type NextPageWithLayout = NextPage & {
  // eslint-disable-next-line no-unused-vars
  getLayout?: (page: ReactElement) => ReactNode
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

function MyApp ({ Component, pageProps }: AppPropsWithLayout): ReactElement {
  const getLayout = Component.getLayout ?? ((page) => page)

  return (
    <>
      <Head>
        <meta name="description" content="WastePay payment processing" />

        <link rel="prefetch" href={process.env.NEXT_PUBLIC_ELAVON_CHECKOUT_JS_URL} as="script" />
      </Head>

      {getLayout(<Component {...pageProps} />)}
    </>
  )
}

export default MyApp
